import {
  alarmOutline,
  bookOutline,
  bulbOutline,
  calendarOutline,
  callOutline,
  chatbubblesOutline,
  checkmarkCircleOutline,
  clipboardOutline,
  documentTextOutline,
  fitnessOutline,
  flagOutline,
  giftOutline,
  globeOutline,
  heartOutline,
  helpCircleOutline,
  homeOutline,
  informationCircleOutline,
  leafOutline,
  linkOutline,
  locationOutline,
  mailOutline,
  medkitOutline,
  megaphoneOutline,
  musicalNotesOutline,
  peopleOutline,
  playCircleOutline,
  shieldCheckmarkOutline,
  starOutline,
  sunnyOutline,
  videocamOutline,
} from "ionicons/icons";

/**
 * Curated icon set for the iconLinks block. The icon NAME is part of the stored block
 * data, so this list is a cross-repo contract — MUST stay in sync with
 * diapasonmentalplus/src/components/UI/atoms/RichTextEditor/richContentIcons.ts
 * (the authoring picker offers exactly these names). Unknown names fall back to
 * link-outline so stale content never renders an empty glyph.
 */
export const RICH_CONTENT_ICONS: Record<string, string> = {
  "alarm-outline": alarmOutline,
  "book-outline": bookOutline,
  "bulb-outline": bulbOutline,
  "calendar-outline": calendarOutline,
  "call-outline": callOutline,
  "chatbubbles-outline": chatbubblesOutline,
  "checkmark-circle-outline": checkmarkCircleOutline,
  "clipboard-outline": clipboardOutline,
  "document-text-outline": documentTextOutline,
  "fitness-outline": fitnessOutline,
  "flag-outline": flagOutline,
  "gift-outline": giftOutline,
  "globe-outline": globeOutline,
  "heart-outline": heartOutline,
  "help-circle-outline": helpCircleOutline,
  "home-outline": homeOutline,
  "information-circle-outline": informationCircleOutline,
  "leaf-outline": leafOutline,
  "link-outline": linkOutline,
  "location-outline": locationOutline,
  "mail-outline": mailOutline,
  "medkit-outline": medkitOutline,
  "megaphone-outline": megaphoneOutline,
  "musical-notes-outline": musicalNotesOutline,
  "people-outline": peopleOutline,
  "play-circle-outline": playCircleOutline,
  "shield-checkmark-outline": shieldCheckmarkOutline,
  "star-outline": starOutline,
  "sunny-outline": sunnyOutline,
  "videocam-outline": videocamOutline,
};

export const resolveRichContentIcon = (name?: string): string =>
  (name && RICH_CONTENT_ICONS[name]) || linkOutline;
